/**
 * Remove any non-digit characters from the input string
 * @param phoneNumberStr - The phone number to clean
 * @returns
 */
export function cleanPhoneNumber(phoneNumberStr: string) {
  if (!phoneNumberStr) return phoneNumberStr;
  const numHasCountryCode = hasCountryCode(phoneNumberStr);
  const cleanedNum = phoneNumberStr.replace(/\D/g, "");
  return numHasCountryCode ? cleanedNum.substring(1) : cleanedNum;
}

function hasCountryCode(phoneNumberStr: string) {
  const pattern = /^\+?1[ -.]?\(?\d{3}\)?[ -.]?\d{3}[ -.]?\d{4}$/;
  return pattern.test(phoneNumberStr);
}

export function formatPhoneNumber(numberStr: string | undefined = "") {
  const clearnStr = cleanPhoneNumber(numberStr);
  const matches = /(\d{0,3})(\d{0,3})(\d{0,4})/.exec(clearnStr) || "";

  return !matches[2]
    ? matches[1]
    : `(${matches[1]})-${matches[2]}${matches[3] ? `-${matches[3]}` : ""}`;
}

// A US national phone number is exactly 10 digits.
export const NATIONAL_PHONE_NUMBER_LENGTH = 10;

/**
 * Progressively group a US national number for a live input field as
 * `XXX-XXX-XXXX`, enforcing the 10-digit maximum — any digits beyond the 10th
 * are truncated. Pasting "+1 913-222-6666" → "913-222-6666" and
 * "(913) 222-6666 7777" → "913-222-6666".
 *
 * Form state holds the formatted display string (e.g. "913-222-6666"), so a
 * caller that needs bare digits must strip the separators itself — e.g.
 * `formatPhoneNumberCognito` runs the value through `cleanPhoneNumber` before
 * sending it to Cognito as `+1XXXXXXXXXX`.
 */
export function formatPhoneNumberInput(numberStr: string | undefined = "") {
  const digits = cleanPhoneNumber(numberStr).slice(0, NATIONAL_PHONE_NUMBER_LENGTH);
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
}

export function formatPhoneNumberAppSync(numberStr: string | undefined = "") {
  const clearnStr = cleanPhoneNumber(numberStr);
  const matches = /(\d{0,3})(\d{0,3})(\d{0,4})/.exec(clearnStr) || "";

  return !matches[2]
    ? matches[1]
    : `${matches[1]}-${matches[2]}${matches[3] ? `-${matches[3]}` : ""}`;
}

export function formatPhoneNumberCognito(numberStr: string | undefined = "") {
  return `+1${cleanPhoneNumber(numberStr)}`;
}
